// Menu Data Constants - Reference & Fallbacks

export const CONCEPTS = [
  { id: "chicken", name: "Krispy Krunchy Chicken", shortName: "Chicken", color: "#F28C38", icon: "Drumstick" },
  { id: "pizza", name: "Hunt Brothers Pizza", shortName: "Pizza", color: "#1A4D4D", icon: "Pizza" },
  { id: "lunch", name: "Daily Specials", shortName: "Daily Specials", color: "#2E7D32", icon: "Sandwich" },
];

// Chicken piece types for selection (Drumsticks/Legs, Thighs, Breast, Wings)
export const CHICKEN_PIECES = [
  { id: "drumstick", name: "Drumstick/Leg" },
  { id: "thigh", name: "Thigh" },
  { id: "breast", name: "Breast" },
  { id: "wing", name: "Wing" },
];

// Biscuit flavors
export const BISCUITS = [
  { id: "honey_butter", name: "Honey Butter" },
  { id: "blueberry", name: "Blueberry" },
];

// Sides with pricing (includes fries)
export const SIDES_LIST = [
  { id: "fries", name: "French Fries", priceRegular: 3.99, priceLarge: 5.99 },
  { id: "mashed_potatoes", name: "Mashed Potatoes & Gravy", priceRegular: 2.99, priceLarge: 5.99 },
  { id: "mac_cheese", name: "Mac-N-Cheese", priceRegular: 2.99, priceLarge: 5.99 },
  { id: "jambalaya", name: "Jambalaya", priceRegular: 2.99, priceLarge: 5.99 },
  { id: "red_beans_rice", name: "Red Beans & Rice", priceRegular: 2.99, priceLarge: 5.99 },
  { id: "wedges", name: "Wedges", priceRegular: 2.99, priceLarge: 4.99, priceFamily: 5.99 },
];

// Wing flavors (for Traditional Wings) - 3 options
export const WING_FLAVORS = [
  { id: "krispy", name: "Krispy" },
  { id: "buffalo", name: "Buffalo" },
  { id: "kkc_fried", name: "Krispy Krunchy Fried" },
];

// Keep WING_SAUCES for backward compatibility
export const WING_SAUCES = WING_FLAVORS;

// Dipping sauces for chicken items - No Sweet & Sour
export const DIPPING_SAUCES = [
  { id: "original", name: "Original" },
  { id: "bbq", name: "Barbecue" },
  { id: "honey_mustard", name: "Honey Mustard" },
  { id: "ranch", name: "Ranch" },
  { id: "buffalo", name: "Buffalo" },
];

// Extra sauce price
export const EXTRA_SAUCE_PRICE = 0.79;

// Free sauces by price tier (fallback if item doesn't specify)
export const SAUCE_TIERS = {
  tier1: { maxSubtotal: 9.99, freeSauces: 1 },
  tier2: { minSubtotal: 10, maxSubtotal: 14.99, freeSauces: 2 },
  tier3: { minSubtotal: 15, freeSauces: 3 },
};

// Get free sauce count - can be overridden per item
export const getFreeSauceCount = (price, itemFreeSauces = null) => {
  // If item has explicit free_sauces, use that
  if (itemFreeSauces !== null && itemFreeSauces !== undefined) {
    return itemFreeSauces;
  }
  // Otherwise use price-based tier
  if (price >= 15) return 3;
  if (price >= 10) return 2;
  if (price > 0) return 1;
  return 0;
};

// Pizza
export const PIZZA_CRUSTS = [
  { id: "regular", name: "Regular Crust" },
  { id: "thin", name: "Thin Crust" },
];

// Hunt Brothers Pizza Toppings
export const PIZZA_TOPPINGS = {
  meats: ["Pepperoni", "Italian Sausage", "Beef", "Bacon"],
  veggies: ["Onion", "Green Bell Peppers", "Sliced Black Olives", "Mushroom", "Jalapenos", "Banana Peppers"],
};

// Pizza pricing - First pizza $11.99, second pizza $10.99 (alternating pattern)
// Extra cheese always charged separately
export const PIZZA_PRICING = {
  firstPizza: 11.99,
  secondPizza: 10.99,
  extraCheese: 2.49,
};

// Get pizza price based on position in cart (1st, 2nd, 3rd, etc.)
export const getPizzaPrice = (pizzaIndex) => {
  // Odd positions (1st, 3rd, 5th...) = $11.99, Even positions (2nd, 4th, 6th...) = $10.99
  return pizzaIndex % 2 === 1 ? PIZZA_PRICING.firstPizza : PIZZA_PRICING.secondPizza;
};

// Burger toppings
export const BURGER_TOPPINGS = ["Ketchup", "Mayo", "Mustard", "Onion", "Tomato", "Pickles", "Lettuce"];

// Brand Colors
export const BRAND_COLORS = {
  sunsetOrange: "#F28C38",
  deepTeal: "#1A4D4D",
  tropicalAqua: "#59C3C3",
  sandWhite: "#F9F9F9",
  darkSlate: "#2D3436",
};

// Brand Logos
export const BRAND_LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_foodapp-24/artifacts/qn823x2x_PHOTO-2026-02-06-16-32-00.jpg",
  chicken: "https://customer-assets.emergentagent.com/job_foodapp-24/artifacts/2j2q7r5p_KKC-Logo.webp",
  pizza: "https://customer-assets.emergentagent.com/job_foodapp-24/artifacts/2iv7onaz_hunts.gif",
  burgers: "https://customer-assets.emergentagent.com/job_foodapp-24/artifacts/cm4tv0mw_cb.webp",
};

// Images
export const IMAGES = {
  chicken_hero: "https://images.unsplash.com/photo-1688940738506-acfe9334bf5c?w=400&q=80",
  pizza_hero: "https://images.unsplash.com/photo-1650327381366-c6dc88f8b9fe?w=400&q=80",
  burger_hero: "https://images.unsplash.com/photo-1676300185026-81a05335809f?w=400&q=80",
  tenders: "https://images.unsplash.com/photo-1758578484486-74373f45b0b7?w=400&q=80",
  burger_bacon: "https://images.unsplash.com/photo-1619810816144-68dbc1f695e8?w=400&q=80",
  fries: "https://images.unsplash.com/photo-1585772925649-04629455a6e6?w=400&q=80",
  logo: "https://customer-assets.emergentagent.com/job_foodapp-24/artifacts/qn823x2x_PHOTO-2026-02-06-16-32-00.jpg",
  // Hero Banners
  kkc_video_banner: "https://customer-assets.emergentagent.com/job_menuhub-manager/artifacts/vm2b0q2h_KKC_FreshleyMade_25s_GENERIC.mp4",
  hunt_brothers_banner: "https://customer-assets.emergentagent.com/job_7a361128-63ed-4885-961d-c5f2d2b6c611/artifacts/vx4w563k_huntbrothersheader.png",
};

export const formatPrice = (price) => `$${price.toFixed(2)}`;
